function updateLocalStorage(storeName, value) {
  if (!storeName) throw new Error('No storeName!');
  localStorage.setItem(storeName, JSON.stringify(value));
}

export default {
  get: storeName => {
    if (!storeName) throw new Error('No storeName!');
    if (typeof localStorage === 'undefined') return {};
    const stored = localStorage.getItem(storeName) || '{}';
    return JSON.parse(stored);
  },

  set(storeName, value) {
    updateLocalStorage(storeName, value);
  }
}



// WEBPACK FOOTER //
// ./src/setting-saver.js